export const BUILD_INFO = { 
  buildNumber: '1764693063742', 
  buildDate: '2025-12-02 16:31:03 UTC',
  gitBranch: 'oyvindh/To-Antd',
  gitCommitHash: '7b1f5f9'
};
